import React, {useState} from 'react'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import SearchFields from './SearchFields'
import SearchResults from './SearchResults'

const Browse = ({estateId, selectedPhotos, selectedPhotosReducer, setStep}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchSeason, setSearchSeason] = useState('')

  return (
    <>
      <Heading level={2}>Kjøp bilder fra nærområdet</Heading>

      <SearchFields
        searchSeason={searchSeason}
        searchQuery={searchQuery}
        setSearchSeason={setSearchSeason}
        setSearchQuery={setSearchQuery}
      />

      <SearchResults
        estateId={estateId}
        searchQuery={searchQuery}
        searchSeason={searchSeason}
        selectedPhotos={selectedPhotos}
        selectedPhotosReducer={selectedPhotosReducer}
      />

      <div className="actions">
        <Button
          type="navigation"
          disabled={selectedPhotos.length === 0}
          onClick={() => setStep('approve')}
        >
          Se over valgte bilder
        </Button>
      </div>
    </>
  )
}

export default Browse
